const Error =() =>{
    return(
        <div>Error Msg</div>
    )
}
export default Error;